export const INVENT_OAUTH_CALLBACK_URL = "https://api.icp.invent.us/v1/pea/public/oidc"

export const INVENT_OAUTH_RESPONSE_TYPE = "code"
export const INVENT_OAUTH_AUTHORIZATION_CODE_GRANT = INVENT_OAUTH_RESPONSE_TYPE === "code"
export const INVENT_OAUTH_RESOURCE_SERVER_IDENTIFIER = "legacy-keeper-api"
export const INVENT_OAUTH_FULL_ACCESS_SCOPE_NAME = "full-access"

export const INVENT_OAUTH_SCOPES = [
  "openid",
  "email",
  "profile",
  `${INVENT_OAUTH_RESOURCE_SERVER_IDENTIFIER}/${INVENT_OAUTH_FULL_ACCESS_SCOPE_NAME}`,
] as const
